<template>
    <div>
        <div class="rich-container">
            <div class="rich-editor document-editor">
                <div :id="'toolbar-container' + id" class="document-editor__toolbar" />
                <div class="document-editor__editable-container">
                    <div ref="editor" :id="'editor' + id" class="document-editor__editable"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import "@ckeditor/ckeditor5-build-decoupled-document/build/translations/zh-cn";
import UploadAdapter from "../../views/Home/DD_schedule/uploadAdapter.js";
export default {
    name: "ckeditor4",
    props: {
        value: {
            type: String,
            default: "",
        },
        func: {
            type: Function,
            default: function () { },
        },
        disable: {
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        const self = this
        this.initCKEditor();

    },
    data() {
        return {
            id: parseInt(Math.random() * 10000).toString(),
            ckeditor: null,
            editor: null,//编辑器实例
        };
    },
    methods: {
        initCKEditor() {
            const _this = this;
            // 初始化编辑器
            DecoupledEditor.create(document.querySelector(`#editor${_this.id}`), {
                language: "zh-cn", // 中文
                removePlugins: ["MediaEmbed"], // 除去视频按钮
                toolbar: {
                    items: [ //工具栏
                        // "heading",//段落或标题样式
                        // "|",
                        // "fontfamily",//字体
                        // "fontsize",//字体大小
                        // "|",
                        // "alignment",//对齐
                        // "|",
                        // "fontColor",//字体颜色
                        // "fontBackgroundColor",//背景颜色
                        // "|",
                        // "bold",//加粗
                        // "italic",//倾斜
                        // "strikethrough",//删除线
                        // "underline",//下划线
                        // "|",
                        // "link",//超链接
                        // "|",
                        // "outdent",//减少缩进
                        // "indent",//增加缩进
                        // "|",
                        // "bulletedList",//项目符号列表
                        // "numberedList",//项目编号列表
                        // "|",
                        // "insertTable",//插入表格
                        // "|",
                        "uploadImage",//插入图片
                        // "blockQuote",//引用
                        "|",
                        "undo",//撤销
                        "redo",//重做
                    ]
                }
            })
                .then((editor) => {
                    editor.plugins.get("FileRepository").createUploadAdapter = (
                        loader
                    ) => {
                        return new UploadAdapter(loader);
                    };
                    const toolbarContainer = document.querySelector(`#toolbar-container${_this.id}`);
                    toolbarContainer.appendChild(editor.ui.view.toolbar.element);
                    this.editor = editor; // 将编辑器保存起来，用来随时获取编辑器中的内容等，执行一些操作
                    this.editor.setData(_this.value);
                    this.editor.isReadOnly = _this.disable;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
    },
    watch: {
        // 监听prop的变化，更新ckeditor中的值
        value: function () {
            if (this.value !== this.editor.getData()) {
                this.editor.setData(this.value);
            }
        },
    },
    // 销毁组件前，销毁编辑器
    // beforeDestroy: function() {
    //   self.ckeditor.destroy();
    // }
};
</script>
<style lang="scss" scoped>
// .rich-container {
//     height: 600px;
// }


.ck.ck-editor__editable:not(.ck-editor__nested-editable) {
    // min-height: 150px !important;
    min-height: 700px !important;
}
</style>
  